<template>
    <div>
        <div class="field">
            <p class="control has-icons-left">
                <span class="select">
                   <select v-model="invoiceDetailsId">
                      <option :value="null" disabled>Select Invoice Details</option>
                      <option v-for="detail in invoiceDetails" :value="detail.id">{{ detail.name }}, {{ detail.city }}</option>
                   </select>
                </span>
                <span class="icon is-small is-left">
                   <i class="fas fa-globe"></i>
                </span>
            </p>
        </div>
        <div class="field">
            <p class="control has-icons-left">
                <span class="select">
                   <select v-model="shippingType">
                      <option :value="null" disabled>Select Shipping Type</option>
                      <option :value="1">RoRo</option>
                      <option :value="2">Container</option>
                   </select>
                </span>
                <span class="icon is-small is-left">
                   <i class="fas fa-globe"></i>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    import apiInvoiceDetails from '../../../../api/apiInvoiceDetails'
    export default {
        data() {
            return {
                invoiceDetails: []
            }
        },
        computed: {
           invoiceDetailsId: {
               get() {
                    return this.$store.getters.getCustomInvoiceQuery.invoice_details_id
               },
               set(value) {
                    this.$store.dispatch('changeCustomInvoiceQueryFieldValue', {field: 'invoice_details_id', value: value })
               }
           },
           shippingType: {
               get() {
                   return this.$store.getters.getCustomInvoiceQuery.shipping_type
               },
               set(value) {
                   this.$store.dispatch('changeCustomInvoiceQueryFieldValue', {field: 'shipping_type', value: value })
               }
           }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSelectTypeAndDetails.vue